import { isNil } from "lodash-es";
import type React from "react";
import { Badge } from "../../../components/Theme/badge.tsx";
import type { IssueWithAssetRegister } from "../../../kubb";

export function IssueOpenBadge(props: {
  issue: IssueWithAssetRegister;
}): React.ReactNode {
  const { issue } = props;
  if (isNil(issue.end_date_time)) return <Badge color={"red"}>open</Badge>;
  return null;
}
